<template>
  <div class="modal-backdrop">
    <div class="card deletecard bordernone borderadius12 col-lg-4 col-md-8 mt-md-4 col-11 p-0">
      <div class="modal-content borderadius12 p-2">
        <div class="modal-header delete-modal">
            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to inactivate this job ?</h5>
            <button type="button" class="close" @click="closeActiveInactiveJobModal('NOT SUCCESS')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <span class="fontsize14 black80 proximanova text-center pl-3 pr-3 mb-3">You are not going to receive any applications to this job once it is updated to inactive</span>
        <div class="modal-body modal-delete text-center">
            <span class="btn border button-cancel11 borderradius20 mr-2 pr-4 pl-4 navtoPage proximanova" @click="closeActiveInactiveJobModal('NOT SUCCESS')">No</span>
            <span class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd pr-4 pl-4 pointer proximanova" @click="closeActiveInactiveJobModal('SUCCESS')">Yes</span>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return{
          
        }
    },
    mounted() {
    },
    methods: {
        closeActiveInactiveJobModal : function(status) {
          this.$emit('closeActiveInactiveJobModal', status);
        },
    },
    beforeDestroy() {
        
    }
}
</script>

<style scoped>
.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000 !important;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
button:active {
    outline: none;
    border: none;
}
.btn:focus{
  box-shadow: none;
}
.card{
    margin: 0 auto;
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.deletecard{
    margin-top: 15% !important;
}
</style>